import { Card } from "@mui/material";
import { useEffect, useMemo, useState } from "react";
import { AddOutlined, CheckBoxOutlined, CropSquareOutlined } from "@mui/icons-material";

import Box from "../../components/Box";
import Helpers from "../../commons/helpers";
import Button from "../../components/Button";
import useStrings from "../../hooks/useStrings";
import DataTable from "../../components/DataTable";
import Typography from "../../components/Typography";
import UserGroupService from "../../services/identity/userGroup.service";
import ModalCreateUpdateWorkingGroup from "./modalUpdateWorkingGroup";

import { ICodename } from "../../commons/interfaces";
import { Constants } from "../../constants/constants";
import { useCommonComponentContext } from "../../providers/CommonComponentProvider";
import { ActionRequest, GroupUserDefault, IsTrue, Mode, } from "../../constants/enums";
import ModalCreateWorkingGroup from "./modalCreateWorkingGroup";



export interface IitemWorkingGroup {
    id?: string;
    action?: number;
    groupId?: string;
    manager?: number;
    default?: number;
    userTitle?: string;
}

export type IRecordWorkingGroup = IitemWorkingGroup & {
    gene?: string;
    groupName?: string;
    groupCode?: string;
}

const CardUserGroup = (props: {
    mode: number;
    userId?: string;
    organizationId?: string;

    isInvitation?: boolean;
    isPermissionCheckGroupManager?: boolean;

    newLableStaff?: string;
    newLableGroup?: string;
    dataGroupSelect?: ICodename[];
    dataUserTitleSelect?: ICodename[];

    dataRowsUserGroup?: IRecordWorkingGroup[];
    onCallBack?: (dataRows?: IRecordWorkingGroup[]) => void;
}) => {
    const strings = useStrings();

    const {
        onError,
        onSuccess,
        onShowLoading,
        onHideLoading,
    } = useCommonComponentContext();

    const [visibleModalUpdate, setVisibleModalUpdate] = useState<boolean>(false);
    const [visibleModalCreate, setVisibleModalCreate] = useState<boolean>(false);
    const [dataRowsUserGroup, setDataRowsUserGroup] = useState<IRecordWorkingGroup[]>([]);
    const [itemWorkingGroup, setItemWorkingGroup] = useState<IRecordWorkingGroup | undefined>(undefined);

    useEffect(() => {
        setDataRowsUserGroup([...props.dataRowsUserGroup || []]);
    }, [props.dataRowsUserGroup])

    const handleDeleteItemRow = (row: IRecordWorkingGroup) => {
        let tableDataTemp = [...dataRowsUserGroup || []];
        let index = tableDataTemp.findIndex((e) => ((e.groupId === row?.groupId)));

        if (Number(tableDataTemp[index].action || 0) === ActionRequest.Create) {
            const data = tableDataTemp.filter((e) => (e.groupId !== row?.groupId));
            setDataRowsUserGroup(data);
        }

        if (tableDataTemp[index].action === ActionRequest.Update) {
            if (Helpers.isNullOrEmpty(props.userId)) {
                const data = tableDataTemp.filter((e) => (e.groupId !== row?.groupId));
                setDataRowsUserGroup(data);
            } else {
                Helpers.showConfirmAlert(
                    strings.Staff.CONFIRM_DELETE_USER_GROUP,
                    async () => {
                        try {
                            onShowLoading();

                            await UserGroupService.delete({
                                id: tableDataTemp[index].id,
                                organizationId: props.organizationId,
                                isInvitationDetail: props.isInvitation,
                            });

                            const data = tableDataTemp.filter((e) => e.groupId !== row?.groupId);

                            setDataRowsUserGroup(data);

                            onSuccess(strings.Staff.DELETE_USER_GROUP_SUCCESS)
                        } catch (error) {
                            const e = Helpers.renderExceptionError(error);
                            onError(e);
                        } finally {
                            onHideLoading();
                        }
                    }
                )
            }
        }
    };

    const handleActionModalUpdate = async (newItem: IRecordWorkingGroup) => {

        let tableDataTemp = [...dataRowsUserGroup || []].map(el => ({
            ...el,
            default: (newItem?.default === GroupUserDefault.Default)
                ? GroupUserDefault.None
                : el.default,
        } as IRecordWorkingGroup));

        let indexItem = tableDataTemp.findIndex((e) => ((e.groupId === newItem?.groupId)));

        if (Helpers.isNullOrEmpty(props.userId)) {
            if (indexItem !== -1) {
                tableDataTemp[indexItem] = {
                    ...newItem,
                    action: ActionRequest.Update,
                };

                setDataRowsUserGroup(tableDataTemp);
            } else {

            }
        } else {
            try {
                onShowLoading();

                if (indexItem !== -1) {
                    let newReq: any = {
                        userId: props.userId,
                        organizationId: props.organizationId,

                        id: newItem?.id,
                        groupId: newItem?.groupId,
                        default: newItem?.default,
                        manager: newItem?.manager,
                        userTitle: newItem?.userTitle,
                    };

                    const result = await UserGroupService.update(newReq);

                    tableDataTemp[indexItem] = {
                        ...newItem,
                        id: result.result,
                        action: ActionRequest.Update,
                    };

                    setDataRowsUserGroup(tableDataTemp);

                    onSuccess(strings.Staff.UPDATE_USER_GROUP_SUCCESS);
                } else {

                }
            } catch (error) {
                const e = Helpers.renderExceptionError(error);
                onError(e);
            } finally {
                onHideLoading();
            }
        }
    };

    const handleActionModalCreate = async (newItems: IRecordWorkingGroup[]) => {
        const indexValueDefault = newItems.findIndex(el => el.default === GroupUserDefault.Default);

        let tableDataTemp = [...dataRowsUserGroup || []].map(el => ({
            ...el,
            default: (indexValueDefault === -1)
                ? el.default
                : GroupUserDefault.None
        } as IRecordWorkingGroup));

        if (Helpers.isNullOrEmpty(props.userId)) {
            for (const element of newItems) {
                let valDefault = element?.default;

                if (
                    (indexValueDefault === -1) &&
                    (tableDataTemp.length === 0) &&
                    (element?.default !== GroupUserDefault.Default)
                ) {
                    valDefault = GroupUserDefault.Default;
                }

                const rowTemp = {
                    ...element,
                    default: valDefault,
                    action: ActionRequest.Create,
                };

                tableDataTemp.push(rowTemp);
            };

            setDataRowsUserGroup(tableDataTemp);
        } else {
            try {
                onShowLoading();

                if (indexValueDefault !== -1) {
                    await Promise.all(tableDataTemp.map(el => (onCallAPIUpdateUserGroup(el))));
                }

                const ressult = await Promise.all(newItems.map(el => (onCallAPICreateUserGroup(el))));

                const newResults = ressult.filter(el => el && !Helpers.isNullOrEmpty(el));

                if (newResults.length > 0) {
                    const newTableDataTemp = [...tableDataTemp || [], ...newResults || []];
                    setDataRowsUserGroup(newTableDataTemp);
                }

            } catch (error) {
                const e = Helpers.renderExceptionError(error);
                onError(e);
            } finally {
                onHideLoading();
            }
        }
    };

    const onCallAPICreateUserGroup = async (newReq: IRecordWorkingGroup) => {
        try {

            const result = await UserGroupService.create({
                userId: props.userId,
                organizationId: props.organizationId,

                groupId: newReq?.groupId,
                default: newReq?.default,
                manager: newReq?.manager,
                userTitle: newReq?.userTitle,
            });

            const newRow: IRecordWorkingGroup = {
                id: result.result,
                default: newReq?.default,
                manager: newReq?.manager,
                userTitle: newReq?.userTitle,
                action: ActionRequest.Update,

                gene: newReq?.gene,
                groupId: newReq?.groupId,
                groupName: newReq?.groupName,
                groupCode: newReq?.groupCode,
            };
            return newRow;
        } catch (error) {
            return undefined;
        }
    };

    const onCallAPIUpdateUserGroup = async (newReq: IRecordWorkingGroup) => {
        try {

            await UserGroupService.update({
                userId: props.userId,
                organizationId: props.organizationId,

                id: newReq?.id,
                groupId: newReq?.groupId,
                default: newReq?.default,
                manager: newReq?.manager,
                userTitle: newReq?.userTitle,
            });

            return newReq?.id;
        } catch (error) {
            return undefined;
        }
    };

    const handleCloseModal = () => {
        setVisibleModalCreate(false);
        setVisibleModalUpdate(false);
        setItemWorkingGroup(undefined);
    };

    const handleOpenModalUpdate = async (row: IRecordWorkingGroup) => {
        setItemWorkingGroup({
            id: row?.id,
            gene: row?.gene,
            action: row?.action,
            groupId: row?.groupId,
            manager: row?.manager,
            default: row?.default,
            userTitle: row?.userTitle,
            groupCode: row?.groupCode,
            groupName: row?.groupName,
        });

        setVisibleModalUpdate(true);
    };

    return (
        <Card>
            <Box p={2}>
                <Box sx={{
                    gap: 1,
                    display: "flex",
                    flexWrap: "wrap",
                    alignItems: "center",
                    justifyContent: "space-between",
                }}>
                    <Typography variant="h5">
                        {Helpers.capitalizeFirstLetter(strings.format(strings.Staff.WORK_GROUPS, props.newLableGroup))}
                    </Typography>
                    {
                        (props.mode !== Mode.View) &&
                        <Button onClick={() => { setVisibleModalCreate(true); }} >
                            <AddOutlined />&nbsp;
                            {strings.Common.ADD_NEW}
                        </Button>
                    }
                </Box>

                {/* List Working Group */}
                <Box p={2}>
                    <DataTable
                        isLocal
                        pageNumber={1}
                        mode={props.mode}
                        rowPerPage={Constants.ROW_PER_PAGE}
                        totalCount={dataRowsUserGroup?.length}
                        hideActionMenu={(props.mode === Mode.View)}

                        table={{
                            rows: dataRowsUserGroup || [],
                            columns: [
                                {
                                    Header: Helpers.capitalizeFirstLetter(strings.format(strings.Group.NAME_GROUP, props.newLableGroup)), accessor: "groupName", width: "120px",
                                    Cell: (row) => <>{
                                        !Helpers.isNullOrEmpty(row.value)
                                            ? row.value
                                            : (props.dataGroupSelect?.find(e => e.code === row?.row?.original?.groupId)?.name || "")
                                    }</>
                                },
                                {
                                    Header: Helpers.capitalizeFirstLetter(strings.format(strings.Staff.GROUP_DEFAULT, props.newLableGroup)), accessor: "default", width: "130px",
                                    Cell: (row) => (Number(row.value) === GroupUserDefault.Default)
                                        ? <CheckBoxOutlined /> : <CropSquareOutlined />
                                },
                                {
                                    Header: Helpers.capitalizeFirstLetter(strings.format(strings.Staff.MANAGER_GROUP, props.newLableGroup)), accessor: "manager", width: "100px",
                                    Cell: (row) => (Number(row.value) === IsTrue.True)
                                        ? <CheckBoxOutlined /> : <CropSquareOutlined />
                                },
                                {
                                    Header: Helpers.capitalizeFirstLetter(strings.format(strings.Staff.STAFF_POSITION, props.newLableStaff)), accessor: "userTitle", width: "150px",
                                    Cell: (row) => <>{props.dataUserTitleSelect?.find((e) => e.code === row.value)?.name}</>,
                                },
                            ],
                        }}

                        actionList={row => {
                            const index = props.dataGroupSelect?.findIndex(el => el.code === row.groupId);

                            return (index !== -1)
                                ? [
                                    {
                                        key: "edit",
                                        iconName: "edit",
                                        title: strings.Common.EDIT,
                                        callback: (row) => { handleOpenModalUpdate(row) },
                                    },
                                    {
                                        key: "delete",
                                        iconName: "delete",
                                        title: strings.Common.DELETE,
                                        callback: (row) => { handleDeleteItemRow(row) },
                                    },
                                ]
                                : []
                        }}
                    />
                </Box>
            </Box>

            {/* Modal Create or Update Working Group */}
            {visibleModalUpdate &&
                <ModalCreateUpdateWorkingGroup
                    mode={props.mode}
                    visibleModal={visibleModalUpdate}

                    newLableGroup={props.newLableGroup}
                    newLableStaff={props.newLableStaff}

                    dataDetail={itemWorkingGroup}
                    dataUserTitleSelect={props.dataUserTitleSelect}
                    isPermissionCheckGroupManager={props.isPermissionCheckGroupManager}

                    onCloseModal={() => { handleCloseModal() }}
                    onActionModal={(newItem) => {
                        newItem && handleActionModalUpdate(newItem);
                        handleCloseModal();
                    }}
                />
            }

            {visibleModalCreate &&
                <ModalCreateWorkingGroup
                    mode={props.mode}
                    visibleModal={visibleModalCreate}
                    newLableGroup={props.newLableGroup}
                    newLableStaff={props.newLableStaff}

                    dataRowsUserGroup={dataRowsUserGroup}
                    dataGroupSelect={props.dataGroupSelect}
                    dataUserTitleSelect={props.dataUserTitleSelect}
                    isPermissionCheckGroupManager={props.isPermissionCheckGroupManager}

                    onCloseModal={() => { handleCloseModal() }}

                    onActionModal={(items) => {
                        if (items.length > 0) {
                            handleActionModalCreate(items)
                        }
                        handleCloseModal();
                    }}
                />
            }
        </Card>
    );
};

export default CardUserGroup;